<template>
  <div class="base-accordion">
    <div class="base-accordion__head f24" @click="open = !open">
      <div class="base-accordion__head__main">
        <IconProjectType v-if="type === 'project'" :extra="extra" revert />
        <EmployeesPhoto
          v-else-if="type === 'employee'"
          :size="40"
          :img="image"
          :textFirst="name.first"
          :textSecond="name.last"
        />
        {{ text }}
      </div>
      <div class="base-accordion__head__buttons">
        <slot name="head-buttons"/>
        <BaseButton
          v-if="show && (show.name || show.params)"
          class="base-accordion__head__button base-accordion__head__button--show"
          @click.stop="
            $router.push({
              name: show.name,
              params: show.params,
            })
          "
          minimalize
          icon_only
          default_icon="button-show"
          size="50"
        />
        <div
          class="base-accordion__head__button"
          :class="{ 'base-accordion__head__button--active': open }"
        >
          <svg
            width="15"
            height="8"
            viewBox="0 0 15 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M-3.14713e-05 6.83004C-0.00053978 6.68065 0.0324326 6.53304 0.0964613 6.39806C0.16049 6.26308 0.253949 6.14416 0.369969 6.05004L6.36997 1.22004C6.5489 1.07296 6.77334 0.992554 7.00497 0.992554C7.23659 0.992554 7.46104 1.07296 7.63997 1.22004L13.64 6.22004C13.8442 6.38978 13.9726 6.63369 13.997 6.89812C14.0214 7.16254 13.9397 7.42583 13.77 7.63004C13.6002 7.83426 13.3563 7.96268 13.0919 7.98706C12.8275 8.01144 12.5642 7.92978 12.36 7.76004L6.99997 3.29004L1.63997 7.61004C1.49318 7.73232 1.31444 7.81 1.12489 7.83388C0.935346 7.85776 0.742921 7.82684 0.570394 7.74479C0.397866 7.66273 0.252455 7.53297 0.151364 7.37086C0.0502739 7.20875 -0.00226307 7.02108 -3.14713e-05 6.83004Z"
              fill="#277FAF"
            />
          </svg>
        </div>
      </div>
    </div>
    <div class="base-accordion__content" :class="{ 'base-accordion__content--show': open }">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import IconProjectType from 'components/icons/project/IconProjectType'
import EmployeesPhoto from 'components/employees/EmployeesPhoto'
export default {
  name: 'BaseAccordion',
  components: { IconProjectType, EmployeesPhoto },
  props: {
    text: [String, Function],
    extra: Boolean,
    type: String,
    image: String,
    name: {
      type: Object,
      default: () => {
        return {
          first: null,
          last: null,
        }
      },
    },
    show: {
      type: Object,
      default: () => {
        return {
          name: null,
          params: null,
        }
      },
    },
  },
  data: () => ({
    open: true,
  }),
}
</script>

<style lang="scss" scoped>
.base-accordion {
  //overflow: hidden;
  &__head {
    //display: flex;
    align-items: center;
    align-content: center;
    //column-gap: 8px;
    display: grid;
    grid-template-columns: auto max-content;
    justify-content: space-between;
    gap: 15px;
    padding: 10px 20px;
    background: #277faf;
    color: #ffffff;
    cursor: pointer;
    user-select: none;
    &__main {
      display: flex;
      justify-content: flex-start;
      gap: 10px;
      align-items: center;
    }
    @media #{map-get($display-breakpoints, 'xs-only')} {
      font-size: 16px !important;
      // grid-template-columns: auto;
      justify-items: start;
    }
    span {
      background: #16558f;
      border-radius: 4px;
      padding: 6px 8px;
    }
    &__buttons {
      display: flex;
      gap: 10px;
      align-items: center;
      @media screen and (max-width: 500px) {
        flex-direction: column;
      }
    }
    &__button {
      background: #f2f2f2;
      border-radius: 10px;
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;

      svg {
        transition: 0.3s;
        transform: rotate(180deg);
      }
      &--active {
        svg {
          transform: none;
        }
      }
    }
  }
  &__content {
    display: none;
    &--show {
      display: block;
    }
  }
}
.padtop6 {
    padding-top: 6px;
}
</style>
